// @flow

import React, { Component, useEffect, useState } from "react";
import $ from "jquery";
import {
  PdfLoader,
  PdfHighlighter,
  Tip,
  Highlight,
  Popup,
  AreaHighlight,
} from "react-pdf-highlighter";
import Spinner from "../../components/Spinner";
import Sidebar from "../../components/Sidebar";
import { bylaw_auth, get_custom_bylaw, get_bylaw_answers, get_preset_bylaw, get_preset_bylaw_categories, get_property_corpus, get_property_corpus_summary, get_property_pdf, insert_new_corpus, save_selections_bylaw, BYLAW_BASE_URL } from "../../api/services";
import EditCorpusModal from "../../components/EditCorpusModal";
import { insertUrlParam } from "../../utilities/helpers";
import encrypt from "../../api/encrypt";
import InlineSpinner from "../../components/InlineSpinner";
import ZoomInButton from "../../assets/zoom-in-button.png"
import ZoomOutButton from "../../assets/zoom-out-button.png"
import PresetChangePopup from '../../components/PresetChangePopup';

const getNextId = () => String(Math.random()).slice(2);

const parseIdFromHash = () =>
  document.location.hash.slice("#highlight-".length);

const resetHash = () => {
  document.location.hash = "";
};

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return rect.y > -300
}

const HighlightPopup = ({ comment }) =>
  comment.text ? (
    <div className="Highlight__popup">
      {comment.emoji} {comment.text}
    </div>
  ) : null;

const initialUrl = "";


class BylawScreen extends Component {
  constructor(props) {
    super(props);
    this.pageInputRef = React.createRef();
  }

  state = {
    property_id: null,
    bylaw_authed: false,
    url: initialUrl,
    highlights: [],
    categories: [],
    corpus_sentance: [],
    preset: [],
    selected_category: "select",
    drop: [],
    corpus_summary: "",
    keywords: [],
    current_page: 1,
    category_from_url: '',
    is_sidebar_loading: true,
    zoomed_in: false,
    searchTerm: '',
    searchResults: [],
    currentSearchIndex: -1,
    currentPageInput: "1",
    isEditingPage: false,
    totalPages: 0,
    showPresetChangePopup: false,
    originalPreset: null,
    newPreset: null,
    irisExplanation: '',
    selectedPresets: [],        // Track the currently selected presets
    irisSelectedPresets: [],    // Track what IRIS originally selected
    justificationText: '',      // Store the user's justification
    isSubmitting: false,         // Track submission state
    explainedCategories: {}      // Add this new property to track which categories have been explained
  };


  componentDidMount(){
    const all =  new URLSearchParams(window.location.search);
    let property_id = null;
    let pid = all.get("pid");
    let word = null;

    try{
      if(pid){
        const decoded_string = encrypt.decryptWithAES(pid);
        const decoded_elements = decoded_string.split(',');
        property_id = decoded_elements[0];
        word = decoded_elements[1];
        if (word == "access"){
          this.setState({bylaw_authed: true})
        }
      }
    }catch(err){
      console.error(err);
    }

    if(word !== "access")  {
      this.props.history.push("/notfound")
    }

    const category = all.get("category");
    this.setState({category_from_url: category});

    if (property_id){
      this.setState({property_id: property_id});

      this.bylaw_categories_data(property_id);
      const trackVisiblePage = () => {
        try {
          const pages = document.querySelectorAll('.page');
          const pdfsection = document.querySelector('.PdfHighlighter');
          
          if (pdfsection) {
            pdfsection.addEventListener('scroll', () => {
              for (let i = 0; i < pages.length; i++) {
                const page = pages[i];
                if (isInViewport(page)) {
                  const pageNum = parseInt(page.dataset.pageNumber, 10);
                  if (pageNum !== this.state.current_page) {
                    this.setState({ current_page: pageNum });
                    if (this.pageInputRef.current) {
                      this.pageInputRef.current.value = pageNum.toString();
                    }
                  }
                  break;
                }
              }
            });
          }
        } catch(err) {
          console.error("Error setting up page tracking:", err);
          setTimeout(trackVisiblePage, 1000);
        }
      };
      
      setTimeout(trackVisiblePage, 1000);
    }

    this.setState({ currentPageInput: "1" });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selected_category !== this.state.selected_category) {
      insertUrlParam('category', this.state.selected_category);
    }
    
    if (prevState.current_page !== this.state.current_page && this.pageInputRef.current) {
      this.pageInputRef.current.value = this.state.current_page.toString();
    }
  }

  resetHighlights = () => {
    this.setState({
      highlights: [],
    });
  };

  scrollViewerTo = (highlight) => {};

  scrollToHighlightFromHash = () => {
    const highlight = this.getHighlightById(parseIdFromHash());
    if (highlight) {
      this.scrollViewerTo(highlight);
    }
  };

  // This is the original submit handler - we'll modify it to be called after the popup
  async handleSubmit(event) {
    if (event) {
      event.preventDefault();
    }
    
    var next = $("#lang > option:selected").next("option");
    var d = { check: [] };
    $("input.selection:checked").each(function () {
      d["check"].push($(this).val());
    });

    // Capture the current selections for comparison later
    const selectedOptions = d["check"];
    this.setState({ selectedPresets: selectedOptions });

    if (this.state.bylaw_authed){
      try{
        this.setState({ saving_bylaw: true });
        await save_selections_bylaw(d, this.state.selected_category, this.state.property_id);
      }catch(err){
        console.error(err);
      }finally{
        await this.bylaw_categories_data(this.state.property_id, false);
        this.setState({ saving_bylaw: false });
        if (next.length > 0) {
          $("#lang > option:selected")
            .removeAttr("selected")
            .next("option")
            .attr("selected", "selected");
          this.change_category(next.val());
          this.setState({ selected_category: next.val() });
        } else {
          this.change_category(this.state.categories[0].key);
          this.setState({ selected_category: this.state.categories[0].key });
        }
      }
    }
  }

  async listCustomBylaw(property_id, category){
    try{
      const get_preset_bylaw_data = await get_custom_bylaw(property_id, category);
      const drops = get_preset_bylaw_data.map((bylaw) => {
        return (
          <div key={bylaw.id} className="fs-14">
            <label htmlFor={bylaw.id}>
                {bylaw.custom_bylaw}
            </label>
          </div>
        )
      });
      this.setState({ drop: [...this.state.drop, ...drops] });
    }catch(err){
      console.error(err);
    }
  }

  async listOptions(category) {
    try {
      const get_preset_bylaw_data = await get_preset_bylaw(this.state.property_id, category);
      let keywords = [];
      get_preset_bylaw_data.forEach(element => {
        const splitted_keywords = element.keywords.split(",");
        keywords = [...keywords, ...splitted_keywords];
        return element.keywords;
      });
      this.setState({ keywords: keywords.filter(onlyUnique) });
      
      // Track IRIS preset selections for the current category
      const irisPresetIds = this.state.preset.map(id => id.toString());
      this.setState({ irisSelectedPresets: irisPresetIds });
      
      // Get IRIS explanation for the selected presets - now using iris_explanation
      let explanation = "";
      for (const preset of this.state.preset) {
        const selectedOption = get_preset_bylaw_data.find(option => option.id === preset);
        console.log(selectedOption);
        if (selectedOption && selectedOption.iris_explanation) {
          explanation = selectedOption.iris_explanation;
          break;
        }
      }
      
      // If no explanation found in selected presets, fall back to first available explanation
      if (!explanation) {
        for (const option of get_preset_bylaw_data) {
          if (option.iris_explanation) {
            explanation = option.iris_explanation;
            break;
          }
        }
      }
      
      if (explanation) {
        this.setState({ irisExplanation: explanation });
      } else {
        // Clear previous explanation if none found for this category
        this.setState({ irisExplanation: "" });
      }
      
      const drops = get_preset_bylaw_data.map((planet) => {
        if (this.state.bylaw_authed)
          return (
            <div key={planet.id} className="checkmark-container checkmark-container-success fs-14">
              <label htmlFor={planet.id}>
                  {planet.bylaw}
                  <input
                    type="checkbox"
                    key = {planet.id}
                    id={planet.id}
                    className="selection"
                    value={planet.id}
                    name="check"
                    defaultChecked={this.state.preset.includes(planet.id)}
                    onChange={this.handlePresetChange}
                  />
                  <span className="checkmark"></span>
              </label>
            </div>
          )
        if(!this.state.bylaw_authed && this.state.preset.includes(planet.id)) {
          return (
            <div key={planet.id} className="fs-14">
              <label htmlFor={planet.id}>
                  {planet.bylaw}
              </label>
            </div>
          )
        }
        return undefined
      });
      let sz = drops.filter(d => d!==undefined);
      this.setState({ drop: sz});
      try{
        if (!this.state.bylaw_authed){
          await this.listCustomBylaw(this.state.property_id, category);
        }
      }catch(err){
        console.error(err);
      }
    }catch(err){console.error(err);}
  }

  // New method to handle preset change
  handlePresetChange = (e) => {
    // Capture the selection change so we can compare it later
    setTimeout(() => {
      const currentSelections = [];
      $("input.selection:checked").each(function() {
        currentSelections.push($(this).val());
      });
      
      // Store the current selection state
      this.setState({ 
        selectedPresets: currentSelections 
      });
    }, 0);
  };
  
  async change_category(new_category) {
    resetHash();
    this.setState({is_sidebar_loading: true})
    try {
      const get_property_pdf_data = await get_property_pdf(this.state.property_id);
      console.log("PDF URL:", get_property_pdf_data);
      this.setState({ url: get_property_pdf_data });
    } catch(err) {
      console.error("Error loading PDF:", err);
    }

    try{
      const get_preset_data = await get_bylaw_answers(this.state.property_id);
      const preset_array = get_preset_data.map((planet) => planet.bylaw_id)
      this.setState({ 
        preset: preset_array,
        originalPreset: preset_array,
        irisSelectedPresets: preset_array
      });
    }catch(err){console.error(err);}

    await this.listOptions(new_category);

    try{
      const get_property_corpus_summary_data = await get_property_corpus_summary(new_category, this.state.property_id);
      const corpus_sum = get_property_corpus_summary_data.map((planet) => {
        return <p key={planet.id}>{planet.corpus_summary}</p>;
      });
      this.setState({ corpus_summary: corpus_sum });
    }catch(err){console.error(err);}

    try{
      const get_property_corpus_data = await get_property_corpus(new_category, this.state.property_id);
      const corpus_highlight = get_property_corpus_data.map((planet) => planet);
      const aa = [];
      corpus_highlight.map((p) => {
        var item = JSON.parse(p.location)
        aa.push({
          content: item.content,
          position: {
            boundingRect: {
              x1: item.position.boundingRect.x1,
              y1: item.position.boundingRect.y1,
              x2: item.position.boundingRect.x2,
              y2: item.position.boundingRect.y2,
              width: item.position.boundingRect.width,
              height: item.position.boundingRect.height
            },
            rects: [
              {
                x1: item.position.rects[0].x1,
                y1: item.position.rects[0].y1,
                x2: item.position.rects[0].x2,
                y2: item.position.rects[0].y2,
                width: item.position.rects[0].width,
                height: item.position.rects[0].height
              }
            ],
            pageNumber:  item.position.pageNumber
          },
          comment: item.comment,
          id: item.id.toString(),
          text_id: p.id,
          selected: p.selected,
          category: p.category,
          property_id : this.state.property_id,
        });

      });
      if (this.state.bylaw_authed){
        this.setState({ highlights: aa });
      }else{
        this.setState({ highlights: aa.filter(a => a.selected) });
      }
      this.setState({is_sidebar_loading: false})
    }catch(err){
      console.log(err);
    }

    window.addEventListener(
      "hashchange",
      this.scrollToHighlightFromHash,
      false
    );
  }

  handleChange(event) {
    const selected_new_category = event.target.value;
    this.setState({ selected_category: selected_new_category});
    this.change_category(event.target.value);
  }

  bylaw_categories_data = async (property_id, set_current_category_flag = true) => {
    try{
      const get_preset_bylaw_categories_data = await get_preset_bylaw_categories(property_id);
      const categories = get_preset_bylaw_categories_data.map((planet) => {
        return <option key={planet.category}>{planet.category}</option>;
      });
      if(categories.length!==0){
        this.setState({ categories: categories });
        if (set_current_category_flag){
          if (this.state.category_from_url){
            this.setState({ selected_category: this.state.category_from_url });
            this.change_category(this.state.category_from_url);
          }
          else{
            this.setState({ selected_category: this.state.categories[0]?.key });
            this.change_category(this.state.categories[0].key);
          }
        }
      return true;
      }
    }catch(err){
      console.log(err);
      return false;
    }
  }

  getHighlightById(id) {
    const { highlights } = this.state;
    return highlights.find((highlight) => {
      const ok = highlight.id === id;
      return ok;
    });
  }

  async addHighlight(highlight) {
      const next_id = getNextId();
      const new_highlight = {
        ...highlight,
        id: next_id
      }
      highlight.id =  getNextId()
      try{
        if (this.state.bylaw_authed){
          await insert_new_corpus(this.state.property_id, new_highlight, this.state.selected_category);
          this.change_category(this.state.selected_category);
        }
      }catch(err){
        console.log(err);
      }
  }

  updateHighlight(highlightId, position, content) {
    this.setState({
      highlights: this.state.highlights.map((h) => {
        return h.id === highlightId
          ? {
              ...h,
              position: { ...h.position, ...position },
              content: { ...h.content, ...content },
            }
          : h;
      }),
    });
  }

  searchDocument = (term) => {
    if (!term) {
      this.removeHighlights();
      this.setState({ searchResults: [], currentSearchIndex: -1, totalSearchResults: 0 });
      return;
    }

    this.removeHighlights();

    const results = this.findTextInDocument(term);

    if (results.length > 0) {
      this.setState({
        searchResults: results,
        currentSearchIndex: 0,
        totalSearchResults: results.length
      }, () => this.highlightCurrentResult());
    } else {
      this.setState({
        searchResults: [],
        currentSearchIndex: -1,
        totalSearchResults: 0
      });
    }
  };


  findTextInDocument = (searchTerm) => {
    const textContent = document.querySelector('.PdfHighlighter').textContent;
    const results = [];
    let index = textContent.toLowerCase().indexOf(searchTerm.toLowerCase());
    while (index !== -1) {
      results.push({
        index: index,
        text: textContent.substr(index, searchTerm.length)
      });
      index = textContent.toLowerCase().indexOf(searchTerm.toLowerCase(), index + 1);
    }
    return results;
  };

  getAllTextNodes = (node) => {
    const textNodes = [];
    if (node.nodeType === Node.TEXT_NODE) {
      textNodes.push(node);
    } else {
      const children = node.childNodes;
      for (let index = 0; index < children.length; index++) {
        textNodes.push(...this.getAllTextNodes(children[index]));
      }
    }
    return textNodes;
  };

  highlightCurrentResult = () => {
    const { searchResults, currentSearchIndex } = this.state;
    if (searchResults.length > 0 && currentSearchIndex !== -1) {
      const result = searchResults[currentSearchIndex];
      const textContent = document.querySelector('.PdfHighlighter').textContent;

      if (textContent.substr(result.index, result.text.length).toLowerCase() === result.text.toLowerCase()) {
        const treeWalker = document.createTreeWalker(
          document.querySelector('.PdfHighlighter'),
          NodeFilter.SHOW_TEXT,
          null,
          false
        );

        let charCount = 0;
        let node;

        while ((node = treeWalker.nextNode())) {
          const nodeLength = node.length;
          if (charCount + nodeLength > result.index) {
            const range = document.createRange();
            const startOffset = result.index - charCount;
            range.setStart(node, startOffset);
            range.setEnd(node, Math.min(startOffset + result.text.length, nodeLength));

            const highlightSpan = document.createElement('span');
            highlightSpan.className = 'search-highlight';
            range.surroundContents(highlightSpan);

            highlightSpan.scrollIntoView({ behavior: 'smooth', block: 'center' });
            break;
          }
          charCount += nodeLength;
        }
      } else {
        this.searchDocument(result.text);
      }
    }
  };

  removeHighlights = () => {
    const highlightedElements = document.querySelectorAll('.search-highlight');
    highlightedElements.forEach((el) => {
      const parent = el.parentNode;
      parent.replaceChild(document.createTextNode(el.textContent), el);
      parent.normalize();
    });
  };

  goToNextResult = () => {
    const { currentSearchIndex, totalSearchResults } = this.state;
    if (totalSearchResults > 0) {
      const nextIndex = (currentSearchIndex + 1) % totalSearchResults;
      this.setState({ currentSearchIndex: nextIndex }, () => {
        this.removeHighlights();
        this.highlightCurrentResult();
      });
    }
  };

  goToPreviousResult = () => {
    const { currentSearchIndex, totalSearchResults } = this.state;
    if (totalSearchResults > 0) {
      const prevIndex = (currentSearchIndex - 1 + totalSearchResults) % totalSearchResults;
      this.setState({ currentSearchIndex: prevIndex }, () => {
        this.removeHighlights();
        this.highlightCurrentResult();
      });
    }
  };

  handleSaveAndNextClick = (event) => {
    event.preventDefault();
    
    const currentSelections = [];
    $("input.selection:checked").each(function() {
      currentSelections.push($(this).val());
    });
    
    const irisSelections = this.state.irisSelectedPresets;
    
    const originalPresetId = irisSelections.length > 0 ? irisSelections[0] : null;
    const modifiedPresetId = currentSelections.length > 0 ? currentSelections[0] : null;
    
    const originalPresetText = this.getPresetLabels(irisSelections);
    const newPresetText = this.getPresetLabels(currentSelections);
    
    const hasChanges = this.hasPresetChanged(currentSelections, irisSelections);
    const hasTextChanges = originalPresetText !== newPresetText;
    
    if (hasChanges && hasTextChanges && this.state.irisExplanation && (originalPresetText !== null && originalPresetText !== "")) {
      this.setState({
        showPresetChangePopup: true,
        originalPreset: originalPresetText,
        newPreset: newPresetText,
        originalPresetId: originalPresetId,
        modifiedPresetId: modifiedPresetId
      });
    } else {
      this.handleSubmit(event);
    }
  };
  
  hasPresetChanged = (currentSelections, irisSelections) => {
    if (currentSelections.length !== irisSelections.length) return true;
    
    const currentSet = new Set(currentSelections.map(id => id.toString()));
    const irisSet = new Set(irisSelections.map(id => id.toString()));
    
    for (const id of irisSet) {
      if (!currentSet.has(id)) return true;
    }
    
    for (const id of currentSet) {
      if (!irisSet.has(id)) return true;
    }
    
    return false;
  };
  
  getPresetLabels = (presetIds) => {
    const labels = [];
    presetIds.forEach(id => {
      const element = document.querySelector(`label[for="${id}"]`);
      if (element) {
        const textContent = element.childNodes[0].textContent.trim();
        labels.push(textContent);
      }
    });
    return labels.join(", ");
  };

  handlePopupSave = async (explanation) => {
    try {
      this.setState({ 
        justificationText: explanation,
        isSubmitting: true,
        explainedCategories: {
          ...this.state.explainedCategories,
          [this.state.selected_category]: true
        }
      });
    
      
      await this.handleSubmit();
      
      this.setState({ 
        showPresetChangePopup: false,
        isSubmitting: false
      });
      
      return Promise.resolve();
    } catch (error) {
      this.setState({ isSubmitting: false });
      console.error("Failed to save justification:", error);
      return Promise.reject(error);
    }
  };

  handlePopupCancel = () => {
    const irisSelections = this.state.irisSelectedPresets;
    
    $("input.selection").prop("checked", false);
    
    irisSelections.forEach(id => {
      $(`input.selection[value="${id}"]`).prop("checked", true);
    });
    
    this.setState({ showPresetChangePopup: false });
  };

  handlePageInputChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    
    if (value !== this.state.currentPageInput) {
      this.setState({ 
        currentPageInput: value,
        isEditingPage: true
      });
    }
  };

  handlePageInputBlur = () => {
    this.handlePageJump();
    this.setState({ isEditingPage: false });
  };

  handlePageInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.handlePageJump();
      this.setState({ isEditingPage: false });
    }
  };

  handlePageJump = () => {
    if (!this.pageInputRef.current) return;
    
    const inputValue = this.pageInputRef.current.value;
    
    if (!/^\d+$/.test(inputValue)) {
      this.pageInputRef.current.value = this.state.current_page.toString();
      return;
    }
    
    const pageNum = parseInt(inputValue, 10);
    
    if (isNaN(pageNum) || pageNum < 1 || pageNum > (this.state.totalPages || 0)) {
      this.pageInputRef.current.value = this.state.current_page.toString();
      return;
    }
    
    const pages = document.querySelectorAll('.page');
    if (pages && pages.length >= pageNum) {
      pages[pageNum - 1].scrollIntoView({ behavior: 'smooth' });
      this.setState({ current_page: pageNum });
    }
  };

  scrollToPage = (pageNum) => {
    try {
      const pages = document.querySelectorAll('.page');
      if (pages && pages.length >= pageNum) {
        pages[pageNum - 1].scrollIntoView({ behavior: 'smooth' });
        if (this.state.current_page !== pageNum) {
          this.setState({ current_page: pageNum });
          if (this.pageInputRef.current) {
            this.pageInputRef.current.value = pageNum.toString();
          }
        }
      }
    } catch (err) {
      console.error("Error scrolling to page:", err);
    }
  };

  // Modified submit handler to check for IRIS preset changes
  handleSaveAndNextClick = (event) => {
    event.preventDefault();
    
    // Get the current selections
    const currentSelections = [];
    $("input.selection:checked").each(function() {
      currentSelections.push($(this).val());
    });
    
    // Check if there are differences between IRIS selection and current selection
    const irisSelections = this.state.irisSelectedPresets;
    const hasChanges = this.hasPresetChanged(currentSelections, irisSelections);

    // Get the original preset ID and the modified preset ID
    const originalPresetId = irisSelections.length > 0 ? irisSelections[0] : null;
    const modifiedPresetId = currentSelections.length > 0 ? currentSelections[0] : null;

    const originalPresetText = this.getPresetLabels(irisSelections);
    const newPresetText = this.getPresetLabels(currentSelections);

    const hasTextChanges = originalPresetText !== newPresetText;
    
    // Only show popup if changes exist AND there's an explanation (LLM processed)
    if (hasChanges && hasTextChanges && this.state.irisExplanation) {
      // If there are changes and explanation exists, show the popup
      this.setState({
        showPresetChangePopup: true,
        originalPreset: this.getPresetLabels(irisSelections),
        newPreset: this.getPresetLabels(currentSelections),
        originalPresetId: originalPresetId,
        modifiedPresetId: modifiedPresetId
      });
    } else {
      // No changes or no IRIS explanation, proceed with normal submission
      this.handleSubmit(event);
    }
  };
  
  // Helper method to compare selections
  hasPresetChanged = (currentSelections, irisSelections) => {
    if (currentSelections.length !== irisSelections.length) return true;
    
    // Convert to strings for comparison
    const currentSet = new Set(currentSelections.map(id => id.toString()));
    const irisSet = new Set(irisSelections.map(id => id.toString()));
    
    // Check if all IRIS selections are in current selections
    for (const id of irisSet) {
      if (!currentSet.has(id)) return true;
    }
    
    // Check if all current selections are in IRIS selections
    for (const id of currentSet) {
      if (!irisSet.has(id)) return true;
    }
    
    return false;
  };
  
  // Helper to get display values for presets
  getPresetLabels = (presetIds) => {
    const labels = [];
    presetIds.forEach(id => {
      const element = document.querySelector(`label[for="${id}"]`);
      if (element) {
        // Get the text content without the nested elements
        const textContent = element.childNodes[0].textContent.trim();
        labels.push(textContent);
      }
    });
    return labels.join(", ");
  };

  // Handler for popup save button
  handlePopupSave = async (explanation) => {
    try {
      // Store the justification text
      this.setState({ 
        justificationText: explanation,
        isSubmitting: true,
        // Mark this category as explained
        explainedCategories: {
          ...this.state.explainedCategories,
          [this.state.selected_category]: true
        }
      });
      
      // Here you would also save the justification to your backend
      // along with the preset changes
      // Example: await saveJustification(this.state.selected_category, explanation);
      
      // Continue with the normal form submission
      await this.handleSubmit();
      
      // Close popup and reset states
      this.setState({ 
        showPresetChangePopup: false,
        isSubmitting: false
      });
      
      return Promise.resolve();
    } catch (error) {
      this.setState({ isSubmitting: false });
      console.error("Failed to save justification:", error);
      return Promise.reject(error);
    }
  };

  // Handler for popup cancel button
  handlePopupCancel = () => {
    // Reset checkboxes to match IRIS selection
    const irisSelections = this.state.irisSelectedPresets;
    
    // Uncheck all checkboxes first
    $("input.selection").prop("checked", false);
    
    // Check only those that were in IRIS selection
    irisSelections.forEach(id => {
      $(`input.selection[value="${id}"]`).prop("checked", true);
    });
    
    // Close popup
    this.setState({ showPresetChangePopup: false });
  };

  render() {
    const { url, highlights } = this.state;
    return (
      <div className="Pdf">
        <div className="container-fluid">
          <div className="row p-4">
            <div
              className="col-md-8"
              style={{
                height: "92vh",
                width: "70vh",
                overflowY: "scroll",
                overflowX: "hidden",
                position: "relative",
              }}
            >
              <div className="card m-3 p-3 bg-secondary  d-flex flex-row justify-content-between search-container" >
                <div>Property ID: {this.state.property_id}</div>
                <div>

                  <span
                    style={{cursor: "pointer"}}
                    onClick={() => {
                      if(this.state.zoomed_in){
                        window.PdfViewer.viewer.currentScaleValue = 1
                        this.setState({zoomed_in: false})
                      }else{
                        window.PdfViewer.viewer.currentScaleValue = 2
                        this.setState({zoomed_in: true})
                      }
                    }}
                  >
                    {this.state.zoomed_in ? <img width={20} src={ZoomOutButton} /> : <img width={20}  src={ZoomInButton} />}
                  </span>

                </div>
                <div className="search-inputs">
                  <input
                    type="text"
                    value={this.state.searchTerm}
                    onChange={(e) => this.setState({ searchTerm: e.target.value })}
                    placeholder="Search..."
                  />
                  <button className="btn-warning" onClick={() => this.searchDocument(this.state.searchTerm)}>Search</button>
                  <button className="previous-button btn-warning" onClick={this.goToPreviousResult}><i className="bi bi-chevron-up"></i></button>
                  <button className="next-button btn-warning" onClick={this.goToNextResult}><i className="bi bi-chevron-down"></i></button>
                  <div>
                    {this.state.totalSearchResults > 0
                      ? `${this.state.currentSearchIndex + 1} / ${this.state.totalSearchResults}`
                      : 'No results'}
                  </div>
                </div>

                <div className="page-navigation">
                  <input
                    type="text"
                    className="page-input"
                    defaultValue={this.state.current_page.toString()}
                    ref={this.pageInputRef}
                    onBlur={this.handlePageJump}
                    onKeyDown={(e) => e.key === 'Enter' && this.handlePageJump()}
                    aria-label="Current page"
                  /> 
                  <span className="page-separator">/</span> 
                  <span className="total-pages">{this.state.totalPages || 0}</span>
                </div>
              </div>
              <div className="pdf-container" style={{ position: 'relative', height: '100%', width: '100%' }}>
                <div className="pdf-scrollbar">
                  <div 
                    className="pdf-scrollbar-thumb"
                    style={{
                      top: `${(this.state.current_page - 1) / (this.state.totalPages - 1 || 1) * 100}%`,
                      height: `${Math.max(8, 100 / (this.state.totalPages || 1))}%`,
                      display:'none'
                    }}
                    onClick={(e) => {
                      const container = e.currentTarget.parentElement;
                      const clickPosition = (e.clientY - container.getBoundingClientRect().top) / container.offsetHeight;
                      const targetPage = Math.max(1, Math.min(this.state.totalPages, Math.ceil(clickPosition * this.state.totalPages)));
                      this.scrollToPage(targetPage);
                    }}
                    onMouseDown={(e) => {
                      // Enable drag scrolling
                      const startY = e.clientY;
                      const startPage = this.state.current_page;
                      const container = e.currentTarget.parentElement;
                      const containerHeight = container.offsetHeight;
                      
                      const handleMouseMove = (moveEvent) => {
                        const deltaY = moveEvent.clientY - startY;
                        const percentageMoved = deltaY / containerHeight;
                        const pagesToMove = Math.round(percentageMoved * this.state.totalPages);
                        const newPage = Math.max(1, Math.min(this.state.totalPages, startPage + pagesToMove));
                        
                        if (newPage !== this.state.current_page) {
                          this.scrollToPage(newPage);
                        }
                      };
                      
                      const handleMouseUp = () => {
                        document.removeEventListener('mousemove', handleMouseMove);
                        document.removeEventListener('mouseup', handleMouseUp);
                      };
                      
                      document.addEventListener('mousemove', handleMouseMove);
                      document.addEventListener('mouseup', handleMouseUp);
                    }}
                  />
                </div>
                
                {url ? (
                  <PdfLoader url={url} beforeLoad={<Spinner mainLoader={true} />} >
                    {(pdfDocument) =>
                    {
                      const numPages = pdfDocument._pdfInfo.numPages;
                      
                      if (numPages !== this.state.totalPages) {
                        this.setState({ totalPages: numPages });
                      }
                      
                      return (
                      <PdfHighlighter
                        pdfDocument={pdfDocument}
                        enableAreaSelection={(event) => event.shift}
                        onScrollChange={() => {
                          resetHash();
                        }}
                        scrollRef={(scrollTo) => {
                          this.scrollViewerTo = scrollTo;
                          this.scrollToHighlightFromHash();
                        }}
                        onSelectionFinished={(
                          position,
                          content,
                          hideTipAndSelection,
                          transformSelection
                        ) => (
                          <Tip
                            onOpen={transformSelection }
                            onConfirm={(comment) => {
                              this.addHighlight({ content, position, comment });
                              hideTipAndSelection();
                            }}
                          />
                        )}
                        highlightTransform={(
                          highlight,
                          index,
                          setTip,
                          hideTip,
                          viewportToScaled,
                          screenshot,
                          isScrolledTo
                        ) => {
                          const isTextHighlight = !Boolean(highlight.content && highlight.content.image);

                          // Compare the current highlight with the active search result
                          const currentResult = this.state.searchResults[this.state.currentSearchIndex];

                          // Check if the current highlight is the one selected in the search
                          const isCurrentSearchResult = currentResult && highlight.position.pageNumber === currentResult.pageNumber &&
                                                        highlight.position.boundingRect === currentResult.boundingRect;

                          // Apply different styles for the current search result
                          const highlightStyle = {
                            backgroundColor: isCurrentSearchResult ? 'yellow' : 'purple', // Current search result in yellow, others in purple
                            opacity: isCurrentSearchResult ? 1 : 0, // Optional: dim other highlights
                          };

                          const component = isTextHighlight ? (
                            <Highlight
                              isScrolledTo={isScrolledTo}
                              position={highlight.position}
                              comment={highlight.comment}
                              style={highlightStyle} // Apply the style here
                            />
                          ) : (
                            <AreaHighlight
                              highlight={highlight}
                              onChange={(boundingRect) => {
                                this.updateHighlight(
                                  highlight.id,
                                  {
                                    boundingRect: viewportToScaled(boundingRect),
                                  },
                                  { image: screenshot(boundingRect) }
                                );
                              }}
                              style={highlightStyle} // Apply the style for area highlights too
                            />
                          );
                          return (
                            <Popup
                              popupContent={<HighlightPopup {...highlight} />}
                              onMouseOver={(popupContent) =>
                                setTip(highlight, (highlight) => popupContent)
                              }
                              onMouseOut={hideTip}
                              key={index}
                              children={component}
                            />
                          );
                        }}

                        highlights={highlights}
                      />
                    )}}
                  </PdfLoader>
                ) : (
                  <div className="no-pdf-message">No document available</div>
                )}
              </div>
            </div>
            <div
              className="col-md-4 sidebar-menu"
              style={{
                height: "97vh",
                width: "100vh",
                overflowY: "scroll",
                overflowX: "hidden",
                position: "relative",
              }}
            >
                <form className="d-flex justify-content-betweens align-items-center" onSubmit={this.handleSaveAndNextClick}>
                    <div className="w-100 rounded-pill ">
                      <select
                        id="lang"
                        className="w-100 custom-select"
                        onChange={this.handleChange.bind(this)}
                        value={this.state.selected_category}
                      >
                        <option>Select</option>
                        {this.state.categories}
                      </select>
                    </div>
                    <div className="col-md-4 float-left h-100">
                      {this.state.saving_bylaw ?
                        <InlineSpinner/>
                      :
                      <input
                        type="submit"
                        className="form-control btn btn-warning text-white shadow font-weight-bold"
                        value={this.state.bylaw_authed ? "Save & Next" : "Next"}
                      />
                    }
                    </div>
                </form>
                <hr />

                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item">
                    <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">

                      {this.state.bylaw_authed ? "Options/Corpus" : "Restrictions"}
                    </a>
                  </li>
                  {
                    this.state.bylaw_authed &&
                    <li className="nav-item">
                      <a className="nav-link" id="contact-tab" data-toggle="tab" href="#keywords" role="tab" aria-controls="keywords" aria-selected="false">Keywords</a>
                    </li>
                  }

                </ul>

              {
              this.state.is_sidebar_loading ?
                <div >
                  <Spinner height={'20vh'}/>
                </div>

              :
              <div className="tab-content" id="myTabContent">
                <div className="card p-4 tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                  <div className="row pl-3 d-block">
                    <p className="font-weight-bold">
                     { this.state.drop.length>0 && ( <>{this.state.bylaw_authed ? "Please select from the options below:" : "Summary"}</>) }
                    </p>
                    <div>
                      {this.state.drop}
                      <input
                        type="hidden"
                        value={this.state.selected_category}
                        id="categroy"
                      />
                    </div>
                  </div>
                  {this.state.bylaw_authed &&

                  <div className="row bg-secondary">
                    <div className="col text-left p-3">
                      <p className="text-black font-weight-bold ">Corpus Summary</p>
                      <div className="fs-12">{this.state.corpus_summary}</div>
                    </div>
                  </div>
                  }
                  <Sidebar
                    highlights={highlights}
                    bylaw_authed = {this.state.bylaw_authed}
                    resetHighlights={this.resetHighlights}
                  />
                </div>
                {BYLAW_BASE_URL === 'https://test-myapi.inspecthoa.com/api/v1.1/bylaws' && <a href={`https://staging.d1eq2evwlplvh6.amplifyapp.com/client?pid=${encodeURIComponent(encrypt.encryptWithAES(this.state.property_id?.toString()))}`} target="_none" className="btn btn-warning mt-3 text-white">Client View</a>}
                {BYLAW_BASE_URL === 'https://myapi.inspecthoa.com/api/v1.1/bylaws' && <a href={`https://summary.inspecthoa.com/client?pid=${encodeURIComponent(encrypt.encryptWithAES(this.state.property_id?.toString()))}`} target="_none" className="btn btn-warning mt-3 text-white">Client View</a>}

                <div className="tab-pane fade mt-2 fs-12" id="keywords" role="tabpanel" aria-labelledby="keywords-tab" >
                  {  this.state.keywords.map((keyword, index) => {
                    return <span key={index} className="badge badge-info  p-2 m-2 fs-12">{keyword}</span>
                  }) }
                </div>
              </div>
              }

            </div>
          </div>
        </div>
        <EditCorpusModal/>
        <PresetChangePopup
          isOpen={this.state.showPresetChangePopup}
          onClose={this.handlePopupCancel}
          onSave={this.handlePopupSave}
          irisSelection={this.state.originalPreset}
          userSelection={this.state.newPreset}
          irisExplanation={this.state.irisExplanation}
          originalPresetId={this.state.originalPresetId}
          modifiedPresetId={this.state.modifiedPresetId}
          propertyId={this.state.property_id}
          category={this.state.selected_category}
        />
      </div>
    );
  }
}

export default BylawScreen;